import cx from 'classnames';
import { Location } from 'history';
import Comment from 'mk2/apps/blogs/components/Comment';
import { CommentsDesign } from 'mk2/apps/blogs/constants';
import { BlogArticleEntity, BlogPostEntity, CommentEntity } from 'mk2/apps/blogs/schemas';
import Complaint from 'mk2/containers/Complaint/Complaint';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import Deletion from 'mk2/containers/Deletion/Deletion';
import { DeletionTargetType } from 'mk2/containers/Deletion/Deletion.schemas';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentList.mscss';

interface OwnProps {
    comments: CommentEntity[];
    parentPost: BlogArticleEntity | BlogPostEntity;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    moderators: UserEntity[];
    hasHiddenText: boolean;
    highlightTriggeredId: number;
    highlightStartedId: number;
    design: CommentsDesign;
    complaintsOpened: boolean[];
    deletionsOpened: boolean[];
    location: Location;

    onDidHighlight?(commentId: number);
    onReply(username: string);
    onDelete(commentId: number);
    onReport(entityType: ComplaintTargetType, commentId: number);
    onSendHeart();
    onToggleMenuMore?(commentId: number);
}

export class CommentList extends React.PureComponent<OwnProps> {

    public render() {
        const {
            comments, requestUser, requestUserPermissions, design,
            highlightStartedId, highlightTriggeredId, isMobile,
            complaintsOpened, location, moderators, parentPost, hasHiddenText, deletionsOpened,
            onDelete, onReport, onDidHighlight, onSendHeart, onToggleMenuMore, onReply,
        } = this.props;

        return (
            <div
                className={cx(
                    styles.CommentList,
                    styles[`CommentList--${CommentsDesign[design]}`],
                )}
            >
                {comments.map((comment, index) => (
                    <div
                        key={comment.id}
                        className={cx(
                            styles.CommentList__commentWrap,
                            complaintsOpened[index] && styles['CommentList__commentWrap--reporting'],
                            deletionsOpened[index] && styles['CommentList__commentWrap--reporting'],
                        )}
                    >
                        <Complaint
                            className={cx(
                                styles.CommentList__complaint,
                                styles[`CommentList__complaint--${CommentsDesign[design]}`],
                            )}
                            entity={ComplaintTargetType.PhotoblogComment}
                            id={comment.id}
                            inForum={false}
                            inGroups={parentPost && 'group' in parentPost && !!parentPost.group}
                        />

                        <Deletion
                            className={cx(
                                styles.CommentList__deletion,
                                styles[`CommentList__deletion--${CommentsDesign[design]}`],
                            )}
                            entity={DeletionTargetType.PhotoblogComment}
                            id={comment.id}
                        />

                        <Comment
                            key={comment.id}
                            inForum={false}
                            inGroups={design === CommentsDesign.Normal}
                            comment={comment}
                            followLinks={false}
                            highlightTriggered={comment.id === highlightTriggeredId}
                            highlightStarted={comment.id === highlightStartedId}
                            isMobile={isMobile}
                            requestUser={requestUser}
                            requestUserPermissions={requestUserPermissions}
                            hasBodyHiddenText={hasHiddenText}
                            hasBodyDeletedStatus={false}
                            hasFooterLike
                            hasFooterReply
                            hasMenu
                            hasMenuReport={design === CommentsDesign.Normal}
                            hasMenuEdit
                            hasMenuDelete={design === CommentsDesign.Normal}
                            hasMenuMoveUp={false}
                            moderators={moderators}
                            onDidHighlight={onDidHighlight}
                            onReply={onReply}
                            onDelete={onDelete}
                            onReport={onReport}
                            onSendHeart={onSendHeart}
                            onToggleMenuMore={onToggleMenuMore}
                            location={location}
                            post={parentPost}
                        />
                    </div>
                ))}
            </div>
        );
    }
}
